import type { RpcTransport } from 'capnweb';

export type RpcSocketTransport = RpcTransport & {
    onMessage: (message: string) => void;
};

/**
 * Utility to create a transport over something a custom socket where the message can be sent the way we want.
 * https://github.com/cloudflare/capnweb/blob/7c4207a4830c5cb50d1c1590cfd4fa22cf50b129/src/websocket.ts#L41
 */
export function createSocketTransport(socket: {
    send: (message: string) => void;
}): RpcSocketTransport {
    let receiveResolver: ((message: string) => void) | undefined;
    const receiveQueue: string[] = [];
    let error: any | undefined;

    return {
        async send(message) {
            socket.send(message);
        },
        async receive() {
            if (receiveQueue.length > 0) {
                return receiveQueue.shift()!;
            } else if (error) {
                throw error;
            } else {
                return new Promise<string>((resolve) => {
                    receiveResolver = resolve;
                });
            }
        },
        abort(reason: any): void {},
        onMessage(message) {
            if (receiveResolver) {
                receiveResolver(message);
            } else {
                receiveQueue.push(message);
            }
        },
    };
}
